export const histogramService = {
  process: async function (originalFilters, data) {
    if (data === undefined || data === null) return;

    let jobType = originalFilters.histograms?.find((x) => {
      return x.type === "jobType";
    });

    if (jobType) {
      let histogramData = data.find((x) => {
        return x.query === jobType.query;
      });

      // Initialize job type count
      originalFilters.jobTypes?.forEach(jobType => jobType.count = 0);

      if (histogramData) {
        let keys = Object.keys(histogramData.values);

        originalFilters.jobTypes.forEach((jobType) => {
          keys.forEach((key) => {
            let jobKey = jobType.key
              .replace(/[A-Z]/g, (letter) => `_${letter.toUpperCase()}`)
              .substring(1)
              .toUpperCase();
            if (key === jobKey) {
              jobType.count = histogramData.values[key];
            }
          });
        });
      }
    }

    let salaries = originalFilters.histograms?.find((x) => {
      return x.type === "Salaries";
    });

    if (salaries) {
      let histogramData = data.find((x) => {
        return x.query === salaries.query;
      });
      
      // Initialize salary count
      originalFilters.salaries?.minimums?.forEach((item) => {
        item.forEach((min) => {
            min.count = 0;
            min.total = 0;
        });
      });

      if (histogramData) {
        let keys = Object.keys(histogramData.values);        

        // Add histogram counts
        originalFilters.salaries?.minimums.forEach((item) => {
          keys.forEach((key) => {
            let keyParts = (key.includes(":") ? key.split(":")[1] : key).split(
              "-",
            );
            var lowerKey = keyParts[0];
            var upperKey = keyParts[1];
            if (upperKey.toUpperCase() === "MAX")
              upperKey = "" + Number.MAX_VALUE;
            item.forEach((min) => {
              if (
                min.key >= parseInt(lowerKey) &&
                min.key <= parseInt(upperKey)
              ) {
                min.count = histogramData.values[key];
              }
            });
          });
        });

        // Total up counts
        originalFilters.salaries?.minimums.forEach((item) => {
          for (var i = item.length - 1; i >= 0; i--) {
            if (i === item.length - 1) {
              if (item[i].count === undefined) item[i].count = 0;
              item[i].total = item[i].count;
            } else {
              if (item[i].count === undefined) item[i].count = 0;
              item[i].total = item[i].count + item[i + 1].total;
            }
          }
        });
      }
    }

    let compUnit = originalFilters.histograms?.find((x) => {
      return x.type === "compUnit";
    });

    if (compUnit) {
      let histogramData = data.find((x) => {
        return x.query === compUnit.query;
      });

      // Initialize salary type count
      originalFilters.salaries?.types?.forEach(type => type.count = 0);

      if (histogramData) {
        let keys = Object.keys(histogramData.values);

        originalFilters.salaries?.types.forEach((type, index) => {
          var max = 0;
          keys.forEach((key) => {
            if (key.toLowerCase() === type.key.toLowerCase()) {
              max = originalFilters.salaries?.minimums[index]?.reduce(
                (a, b) =>
                  b && b.total && b.total > 0 ? Math.max(a, b.total) : a,
                0,
              );
            }
          });
          type.count = max;
        });
      }
    }

    let sectors = originalFilters.histograms?.find((x) => {
      return x.type === "sector";
    });

    if (sectors) {
      let histogramData = data.find((x) => {
        return x.query === sectors.query;
      });

      if (histogramData) {
        originalFilters.customStringAttributes.forEach((item) => {
          let keys = Object.keys(histogramData.values);

          item?.result.forEach((sector) => {
            sector.count = 0;
            keys.forEach((key) => {
              if (key === sector.name) {
                sector.count = histogramData.values[key];
              }
            });
          });
        });
      }
    }

    for (var i = 1; i <= 4; i++) {
      const searchTerm = "sector" + (i > 1 ? i : "");

      let customStringAttributes = originalFilters.histograms?.find((x) => {
        return x.type === searchTerm;
      });

      if (customStringAttributes) {
        let histogramData = data.find((x) => {
          return x.query === customStringAttributes.query;
        });

        if (originalFilters[`customStringAttributes${i}`]) {
          // Initialize customStringAttributesX item count
          originalFilters[`customStringAttributes${i}`].result?.forEach(item => { item.count = 0; });

          if(histogramData) {
              let keys = Object.keys(histogramData.values);
              originalFilters[`customStringAttributes${i}`].result.forEach(
                (item) => {
                  keys.forEach((key) => {
                    if (key === item.name) {
                      item.count = histogramData.values[key];
                    }
                  });
                },
              );
          }
        }
      }
    }

    for (var j = 1; j <= 4; j++) {
      const searchTerm = `sector${j > 1 ? j : ""}_hierarchy`;

      let customStringAttributes = originalFilters.histograms?.find((x) => {
        return x.type === searchTerm;
      });

      if (customStringAttributes) {
        let histogramData = data.find((x) => {
          return x.query === customStringAttributes.query;
        });

        if (originalFilters[`customStringAttributes${j}`]) {
          // Initialize customStringAttributesX item nested count
          originalFilters[`customStringAttributes${j}`].result?.forEach(item => { item.predefinedIdCount = 0; });

          if(histogramData) {
              let keys = Object.keys(histogramData.values);
              originalFilters[`customStringAttributes${j}`].result.forEach(
                (item) => {
                  keys.forEach((key) => {
                    if (key === item.predefinedId) {
                      item.predefinedIdCount = histogramData.values[key];
                    }
                  });
                },
              );
          }
        }
      }
    }

    return originalFilters;
  },
};

export default histogramService;
